import {
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  GET_PROVIDER_SPECIALTY,
  CREATE_PROVIDER_SPECIALTY,
  UPDATE_PROVIDER_SPECIALTY,
  DELETE_PROVIDER_SPECIALTY,
  GET_PROVIDER_SPECIALTY_BY_ID,
} from './actionType';

const INIT_STATE = {
  providerSpecialty: [],
  specialtyById: {},
  error: {},
  success: null,
};

const ProviderSpecialty = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PROVIDER_SPECIALTY:
          return {
            ...state,
            providerSpecialty: action.payload.data,
            success: null,
            error: {},
            specialtyById: {},
          };
        case CREATE_PROVIDER_SPECIALTY:
          return {
            ...state,
            success: 'Successfully created specialty',
            error: {},
          };
        case UPDATE_PROVIDER_SPECIALTY:
          return {
            ...state,
            success: 'Successfully updated specialty',
            error: {},
          };
        case DELETE_PROVIDER_SPECIALTY:
          return {
            ...state,
            success: 'Successfully delete specialty',
            error: {},
          };
        case GET_PROVIDER_SPECIALTY_BY_ID: {
          return {
            ...state,
            success: 'Successfully get specialties by id',
            error: {},
            specialtyById: action.payload.data,
          };
        }
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_PROVIDER_SPECIALTY:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case CREATE_PROVIDER_SPECIALTY:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case UPDATE_PROVIDER_SPECIALTY:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case DELETE_PROVIDER_SPECIALTY:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case GET_PROVIDER_SPECIALTY_BY_ID: {
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        }
        default:
          return { ...state };
      }
    case GET_PROVIDER_SPECIALTY: {
      return {
        ...state,
      };
    }
    case CREATE_PROVIDER_SPECIALTY: {
      return {
        ...state,
      };
    }
    case UPDATE_PROVIDER_SPECIALTY: {
      return {
        ...state,
      };
    }
    case DELETE_PROVIDER_SPECIALTY: {
      return {
        ...state,
      };
    }
    case GET_PROVIDER_SPECIALTY_BY_ID: {
      return {
        ...state,
        specialtyById: {},
      };
    }
    default:
      return { ...state };
  }
};

export default ProviderSpecialty;
